export default "<article class=\"card-dialog\">\n  <img src=\"{{photoURL}}\" alt=\"\">\n</article>"